import React from 'react';
import env from '../../environment';

const IconCheck = () => {
  
  if (env.appEnv === 'dev' || env.appEnv === 'local') {
    return <img style={{ width: 20, height: 20 }} src={env.images.icon.checkFeo} />;
  }
  return (
  <i
    className="fa fa-check"
    aria-hidden="true"
    style={{
      color: env.colors.primary_500,
      marginRight: 10,
    }}
  />
)};

export default IconCheck;
